<template>
    <div class="guide-page">
        <router-view />
    </div>
    <Footer />
</template>

<script>
import Footer from '@/components/Footer.vue';
import { defineComponent } from 'vue';
export default defineComponent({
    components:{Footer}
})
</script>

<style lang="scss" scoped>
.guide-page {
    margin:0 auto;
    background:#f6f6f6;
}
</style>